import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { ChargeMasterApiService } from 'src/app/services/domain_code/charge-master-api.service';
import { ChargeGroupModel } from 'src/app/models/Charge_Master_Model/charge-group';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'logzy-charge-group-form',
    templateUrl: './charge-group-form.component.html',
    styleUrls: ['./charge-group-form.component.scss', '../master-data.scss']
})
export class ChargeGroupFormComponent implements OnInit {
    @Input()
    bindChargeGroup = new BehaviorSubject(null);

    @Output()
    onChargeGroupCreation = new EventEmitter();

    chargeGroupObj: ChargeGroupModel;

    chargeMaster_url = ApiRoutes.ChargeMaster;

    constructor(private snackBar: MatSnackBar, private chargeService: ChargeMasterApiService) { }

    ngOnInit(): void {
        this.resetComponent();
    }

    resetComponent() {
        this.chargeGroupObj = new ChargeGroupModel();

        this.bindChargeGroup.subscribe(item => {
            if (typeof item == 'string') {
                this.chargeGroupObj.name = item;
            } else return;
        });
    }

    saveChargeGroup() {
        if (this.chargeGroupObj.checkChargeGroupErrors()) {
            this.chargeService.postChargeGroup(this.chargeGroupObj.getSavePayload()).subscribe({
                next: res => {
                    this.snackBar.open("Charge Group created successfully!", 'Close', {
                        verticalPosition: 'top',
                        duration: 2000,
                    });
                    this.onChargeGroupCreation.emit(res)
                },
                error: err => {
                    if (err.status > 399 && err.status < 500) {
                        this.chargeGroupObj.mapChargeGroupErrors(err.error);
                    }
                    if (err.status > 499) {
                        this.snackBar.open("Something went wrong! Please try again later.", 'Close', {
                            verticalPosition: 'top',
                            duration: 2000,
                        });
                    }
                }
            });
        }
    }

    editChargeGroupMaster(element) {
        this.chargeGroupObj.saveChargeGroupToPayload(element);
    }

    showAllCharges(event) {
        if (event.flag) {
            this.chargeGroupObj.charges = event.option;
        }
    }
}
